"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withReduxForm = _interopRequireDefault(require("./../../libs/hocs/withReduxForm"));

var _radioItems = _interopRequireDefault(require("./radioItems"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _RequiredAsterisk = _interopRequireDefault(require("../RequiredAsterisk"));

var _utils = require("../../libs/utils");

var _fieldset = _interopRequireDefault(require("./styled/fieldset"));

var _legend = _interopRequireDefault(require("./styled/legend"));

var _errorText = _interopRequireDefault(require("../Input/styled/errorText"));

var _contentContainer = _interopRequireDefault(require("./styled/contentContainer"));

/**
 * A select list that can have a single entry checked at any one time.
 * @category Form
 */
var RadioGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(RadioGroup, _Component);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RadioGroup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioGroup).call(this, props));
    _this.errorId = (0, _utils.uniqueId)('error-message');
    _this.groupNameId = props.name || (0, _utils.uniqueId)('options');
    return _this;
  }

  (0, _createClass2["default"])(RadioGroup, [{
    key: "getErrorMessageId",
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorId;
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          label = _this$props.label,
          required = _this$props.required,
          error = _this$props.error,
          onChange = _this$props.onChange,
          options = _this$props.options,
          value = _this$props.value,
          id = _this$props.id;
      return _react["default"].createElement(_fieldset["default"], {
        id: id,
        className: className,
        style: style
      }, _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!label
      }, _react["default"].createElement(_legend["default"], null, _react["default"].createElement(_RequiredAsterisk["default"], {
        required: required
      }), label)), _react["default"].createElement(_contentContainer["default"], null, _react["default"].createElement(_radioItems["default"], {
        value: value,
        onChange: onChange,
        options: options,
        name: this.groupNameId,
        ariaDescribedby: this.getErrorMessageId(),
        error: error
      })), _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!error
      }, _react["default"].createElement(_errorText["default"], {
        id: this.getErrorMessageId()
      }, error)));
    }
  }]);
  return RadioGroup;
}(_react.Component);

RadioGroup.propTypes = {
  /** The radio group label */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The name of the radio group */
  name: _propTypes["default"].string,

  /** The value of the element. */
  value: _propTypes["default"].string,

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes["default"].func,

  /** If is set to true the radio group is required. This value defaults to false. */
  required: _propTypes["default"].bool,

  /** An array with the radio options. */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    value: _propTypes["default"].string,
    disabled: _propTypes["default"].bool
  })),

  /** Specifies that an radio group must be filled out before submitting the form. */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /** The id of the outer element. */
  id: _propTypes["default"].string
};
RadioGroup.defaultProps = {
  label: null,
  name: null,
  className: undefined,
  style: undefined,
  value: undefined,
  onChange: function onChange() {},
  required: false,
  options: [],
  error: null,
  id: undefined
};

var _default = (0, _withReduxForm["default"])(RadioGroup);

exports["default"] = _default;